import { createContext } from "react";

export const userDetails = {
  user: {
    newsAPI: "8e22364a435e4941bf6c8232770fff59",
    name: "Jigyasu Dhingra",
    email: "jigyasudhingra@gmail.com",
    zerodha: {
      user_id: "RWC093",
      twofa_type: "sms",
      user_name: "Jigyasu Dhingra",
      user_type: "individual",
      email: "jigyasudhingra@gmail.com",
      phone: "*9946",
      broker: "ZERODHA",
      bank_accounts: [
        {
          name: "AXIS BANK",
          branch: "",
          account: "*2708",
        },
      ],
      dp_ids: ["1208160072747512"],
      products: ["CNC", "NRML", "MIS", "BO", "CO"],
      order_types: ["MARKET", "LIMIT", "SL", "SL-M"],
      exchanges: ["BFO", "BSE", "BCD", "CDS", "MF", "NFO", "NSE"],
      pan: "*208F",
      user_shortname: "Jigyasu",
      avatar_url: null,
      tags: [],
      password_timestamp: "2021-10-26 07:50:05",
      twofa_timestamp: "2021-10-26 07:50:05",
      meta: {
        cobrands: [],
        poa: "consent",
        features: ["20depth"],
        silo: "a",
        welcome_email_sent: true,
      },
    },
    upstox: {
      name: "JIGYASU  DHINGRA",
      ucc: "2ZAXN5",
      category: "I",
      email: "jigyasudhingra@gmail.com",
      mobile: "9873219946",
      panno: "GHZPD7208F",
      dob: "23/08/2001",
      nationality: "Indian",
      bankacno: "920010069082708",
      bankname: "AXIS BANK",
      cadd1: "H NO, B 26 BLOCK B OLD",
      cadd2: "QUARTER RAMESH NAGAR RAMESH NAGAR H O",
      cadd3: null,
      cadd4: null,
      ccity: "DELHI",
      cstate: "DELHI",
      cpincode: "110015",
      ccountry: "INDIA",
      demat: {
        dptype: "CDSL",
        dematNumberForIPO: "1208180040751374",
      },
      changeRequests: {},
      customerStatus: "Active",
      reactivationDate: "",
      uccGeneratedDate: "1622053800000",
      isOptedForNominee: false,
      tPin: 1183,
      fatcaDeclare: true,
      userPlanName: "BASICN1-D0",
      userPlanDetails: {
        perTradeAmount: 20,
        perTradePercentage: 0.05,
        deliveryCharges: "Free",
        planName: "Basic Plan",
      },
    },
    scrips: [
      {
        metadata: {
          name: "Alkyl Amines Chemicals Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS03894.png",
          sector: "Chemicals",
          market_cap: "Small Cap",
          ind_key: "INDS03894",
          exchange: "NSE",
          previous_close: 0,
          live_price: 2539.65,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -5.949999999999818,
          day_change_percentage: -0.23,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 1,
          current_value: 2539.65,
          day_pnl: -5.949999999999818,
          avg_price: 0,
          day_pnl_percentage: -0.23,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 1,
          current_value: 2539.65,
          day_pnl: -5.949999999999818,
          avg_price: 0,
          day_pnl_percentage: -0.23,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Andhra Petrochemicals Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS01167.png",
          sector: "Chemicals",
          market_cap: "Small Cap",
          ind_key: "INDS01167",
          exchange: "NSE",
          previous_close: 0,
          live_price: 63,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.5700000000000003,
          day_change_percentage: -0.9,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 6,
          current_value: 378,
          day_pnl: -0.5700000000000003,
          avg_price: 0,
          day_pnl_percentage: -0.9,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 6,
          current_value: 378,
          day_pnl: -0.5700000000000003,
          avg_price: 0,
          day_pnl_percentage: -0.9,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Avenue Supermarts Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS03676.png",
          sector: "Retail",
          market_cap: "Large Cap",
          ind_key: "INDS03676",
          exchange: "NSE",
          previous_close: 0,
          live_price: 3368.55,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -31.649999999999636,
          day_change_percentage: -0.93,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 1,
          current_value: 3368.55,
          day_pnl: -31.649999999999636,
          avg_price: 0,
          day_pnl_percentage: -0.93,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 1,
          current_value: 3368.55,
          day_pnl: -31.649999999999636,
          avg_price: 0,
          day_pnl_percentage: -0.93,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Axis Bank Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS01451.png",
          sector: "Banks",
          market_cap: "Large Cap",
          ind_key: "INDS01451",
          exchange: "NSE",
          previous_close: 0,
          live_price: 914.7,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.09999999999990905,
          day_change_percentage: -0.01,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 12,
          current_value: 10976.4,
          day_pnl: -0.09999999999990905,
          avg_price: 0,
          day_pnl_percentage: -0.01,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 12,
          current_value: 10976.4,
          day_pnl: -0.09999999999990905,
          avg_price: 0,
          day_pnl_percentage: -0.01,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "HDFC Bank Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS01992.png",
          sector: "Banks",
          market_cap: "Large Cap",
          ind_key: "INDS01992",
          exchange: "NSE",
          previous_close: 0,
          live_price: 1645,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: 6.5499999999999545,
          day_change_percentage: 0.4,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 3,
          current_value: 4935,
          day_pnl: 6.5499999999999545,
          avg_price: 0,
          day_pnl_percentage: 0.4,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 3,
          current_value: 4935,
          day_pnl: 6.5499999999999545,
          avg_price: 0,
          day_pnl_percentage: 0.4,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "HDFC Life Insurance Company Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS03123.png",
          sector: "Insurance",
          market_cap: "Large Cap",
          ind_key: "INDS03123",
          exchange: "NSE",
          previous_close: 0,
          live_price: 561.55,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: 1.4499999999999318,
          day_change_percentage: 0.26,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 7,
          current_value: 3930.85,
          day_pnl: 1.4499999999999318,
          avg_price: 0,
          day_pnl_percentage: 0.26,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 7,
          current_value: 3930.85,
          day_pnl: 1.4499999999999318,
          avg_price: 0,
          day_pnl_percentage: 0.26,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Hindustan Unilever Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS01216.png",
          sector: "FMCG",
          market_cap: "Large Cap",
          ind_key: "INDS01216",
          exchange: "NSE",
          previous_close: 0,
          live_price: 2627.55,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -34.19999999999982,
          day_change_percentage: -1.28,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 4,
          current_value: 10510.2,
          day_pnl: -34.19999999999982,
          avg_price: 0,
          day_pnl_percentage: -1.28,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 4,
          current_value: 10510.2,
          day_pnl: -34.19999999999982,
          avg_price: 0,
          day_pnl_percentage: -1.28,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "ICICI Prudential IT ETF",
          logo: "https://cdn.indiawealth.in/public/images/amc_icici.png",
          sector: "ETF",
          market_cap: "",
          ind_key: "INDS16956",
          exchange: "NSE",
          previous_close: 0,
          live_price: 29.1,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.04999999999999716,
          day_change_percentage: -0.17,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 182,
          current_value: 5296.2,
          day_pnl: -0.04999999999999716,
          avg_price: 0,
          day_pnl_percentage: -0.17,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 182,
          current_value: 5296.2,
          day_pnl: -0.04999999999999716,
          avg_price: 0,
          day_pnl_percentage: -0.17,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "ICICI Prudential NV20 ETF",
          logo: "https://cdn.indiawealth.in/public/images/amc_icici.png",
          sector: "ETF",
          market_cap: "",
          ind_key: "INDS16884",
          exchange: "NSE",
          previous_close: 0,
          live_price: 101.96,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.6400000000000006,
          day_change_percentage: -0.62,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 8,
          current_value: 815.68,
          day_pnl: -0.6400000000000006,
          avg_price: 0,
          day_pnl_percentage: -0.62,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 8,
          current_value: 815.68,
          day_pnl: -0.6400000000000006,
          avg_price: 0,
          day_pnl_percentage: -0.62,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "ICICI Prudential Nifty 100 Low Volatility 30 ETF",
          logo: "https://cdn.indiawealth.in/public/images/amc_icici.png",
          sector: "ETF",
          market_cap: "",
          ind_key: "INDS16690",
          exchange: "NSE",
          previous_close: 0,
          live_price: 146.5,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.47999999999998977,
          day_change_percentage: -0.33,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 4,
          current_value: 586,
          day_pnl: -0.47999999999998977,
          avg_price: 0,
          day_pnl_percentage: -0.33,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 4,
          current_value: 586,
          day_pnl: -0.47999999999998977,
          avg_price: 0,
          day_pnl_percentage: -0.33,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "ICICI Prudential Nifty ETF",
          logo: "https://cdn.indiawealth.in/public/images/amc_icici.png",
          sector: "ETF",
          market_cap: "",
          ind_key: "INDS16546",
          exchange: "NSE",
          previous_close: 0,
          live_price: 197.67,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.6000000000000227,
          day_change_percentage: -0.3,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 3,
          current_value: 593.01,
          day_pnl: -0.6000000000000227,
          avg_price: 0,
          day_pnl_percentage: -0.3,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 3,
          current_value: 593.01,
          day_pnl: -0.6000000000000227,
          avg_price: 0,
          day_pnl_percentage: -0.3,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "ICICI Prudential Nifty Next 50 ETF",
          logo: "https://cdn.indiawealth.in/public/images/amc_icici.png",
          sector: "ETF",
          market_cap: "",
          ind_key: "INDS17214",
          exchange: "NSE",
          previous_close: 0,
          live_price: 41.79,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.3500000000000014,
          day_change_percentage: -0.83,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 17,
          current_value: 710.43,
          day_pnl: -0.3500000000000014,
          avg_price: 0,
          day_pnl_percentage: -0.83,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 17,
          current_value: 710.43,
          day_pnl: -0.3500000000000014,
          avg_price: 0,
          day_pnl_percentage: -0.83,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "KPIT Technologies Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS03333.png",
          sector: "IT - Software",
          market_cap: "Mid Cap",
          ind_key: "INDS03333",
          exchange: "NSE",
          previous_close: 0,
          live_price: 941.05,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: 7.899999999999977,
          day_change_percentage: 0.85,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 1,
          current_value: 941.05,
          day_pnl: 7.899999999999977,
          avg_price: 0,
          day_pnl_percentage: 0.85,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 1,
          current_value: 941.05,
          day_pnl: 7.899999999999977,
          avg_price: 0,
          day_pnl_percentage: 0.85,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Manaksia Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS02416.png",
          sector: "Non Ferrous Metals",
          market_cap: "Small Cap",
          ind_key: "INDS02416",
          exchange: "NSE",
          previous_close: 0,
          live_price: 135.15,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.9000000000000057,
          day_change_percentage: -0.66,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 14,
          current_value: 1892.1,
          day_pnl: -0.9000000000000057,
          avg_price: 0,
          day_pnl_percentage: -0.66,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 14,
          current_value: 1892.1,
          day_pnl: -0.9000000000000057,
          avg_price: 0,
          day_pnl_percentage: -0.66,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Motilal Oswal Financial Services Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS03136.png",
          sector: "Finance",
          market_cap: "Small Cap",
          ind_key: "INDS03136",
          exchange: "NSE",
          previous_close: 0,
          live_price: 631.75,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -2.2000000000000455,
          day_change_percentage: -0.35,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 1,
          current_value: 631.75,
          day_pnl: -2.2000000000000455,
          avg_price: 0,
          day_pnl_percentage: -0.35,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 1,
          current_value: 631.75,
          day_pnl: -2.2000000000000455,
          avg_price: 0,
          day_pnl_percentage: -0.35,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Nippon India ETF Nifty 50 BeES",
          logo: "https://cdn.indiawealth.in/public/images/amc_nippon.png",
          sector: "ETF",
          market_cap: "",
          ind_key: "INDS19182",
          exchange: "NSE",
          previous_close: 0,
          live_price: 199.05,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.7099999999999795,
          day_change_percentage: -0.36,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 97,
          current_value: 19307.85,
          day_pnl: -0.7099999999999795,
          avg_price: 0,
          day_pnl_percentage: -0.36,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 97,
          current_value: 19307.85,
          day_pnl: -0.7099999999999795,
          avg_price: 0,
          day_pnl_percentage: -0.36,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Nippon India ETF Nifty Next 50 Junior BeES",
          logo: "https://cdn.indiawealth.in/public/images/amc_nippon.png",
          sector: "ETF",
          market_cap: "",
          ind_key: "INDS20619",
          exchange: "NSE",
          previous_close: 0,
          live_price: 427.18,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -3.990000000000009,
          day_change_percentage: -0.93,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 3,
          current_value: 1281.54,
          day_pnl: -3.990000000000009,
          avg_price: 0,
          day_pnl_percentage: -0.93,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 3,
          current_value: 1281.54,
          day_pnl: -3.990000000000009,
          avg_price: 0,
          day_pnl_percentage: -0.93,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Redington Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS03111.png",
          sector: "Trading",
          market_cap: "Small Cap",
          ind_key: "INDS03111",
          exchange: "NSE",
          previous_close: 0,
          live_price: 170,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -3.4499999999999886,
          day_change_percentage: -1.99,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 15,
          current_value: 2550,
          day_pnl: -3.4499999999999886,
          avg_price: 0,
          day_pnl_percentage: -1.99,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 15,
          current_value: 2550,
          day_pnl: -3.4499999999999886,
          avg_price: 0,
          day_pnl_percentage: -1.99,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Suumaya Industries Ltd",
          logo: "https://cdn.indiawealth.in/public/images/instocks/1X/INDS02662.png",
          sector: "Trading",
          market_cap: "Small Cap",
          ind_key: "INDS02662",
          exchange: "NSE",
          previous_close: 0,
          live_price: 11.85,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: -0.5999999999999996,
          day_change_percentage: -4.82,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 20,
          current_value: 237,
          day_pnl: -0.5999999999999996,
          avg_price: 0,
          day_pnl_percentage: -4.82,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 20,
          current_value: 237,
          day_pnl: -0.5999999999999996,
          avg_price: 0,
          day_pnl_percentage: -4.82,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
      {
        metadata: {
          name: "Winpro Industries Ltd",
          logo: "https://cdn.indiawealth.in/public/images/Stocks.png",
          sector: "Entertainment",
          market_cap: "Small Cap",
          ind_key: "INDS02539",
          exchange: "NSE",
          previous_close: 0,
          live_price: 2.29,
          firebase_path: "",
          socket_path: "",
          corporate_action_metadata: {},
          is_active_stock: true,
          day_change: 0.040000000000000036,
          day_change_percentage: 1.78,
          relativepath: "",
          holding_id: 0,
        },
        holdings: {
          quantity: 16,
          current_value: 36.64,
          day_pnl: 0.040000000000000036,
          avg_price: 0,
          day_pnl_percentage: 1.78,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        aggregated: {
          quantity: 16,
          current_value: 36.64,
          day_pnl: 0.040000000000000036,
          avg_price: 0,
          day_pnl_percentage: 1.78,
          overall_pnl: 0,
          overall_pnl_percentage: 0,
          invested_amount: 0,
          netting_type: "only_buy",
          realised_gains: 0,
          unrealised_gains: 0,
          buy_avg_price: 0,
          sell_avg_price: 0,
          buy_qty: 0,
          sell_qty: 0,
          buy_val: 0,
          sell_val: 0,
          exchange: "",
        },
        sip_data: null,
        open_orders: null,
      },
    ],
    settings: {
      fundamentalRatios: {},
      technicalIndicators: {},
    },
  },
  portfolio: {
    zerodha: [
      {
        tradingsymbol: "ANDHRAPET",
        exchange: "BSE",
        instrument_token: 128003076,
        isin: "INE714B01016",
        product: "CNC",
        price: 0,
        quantity: 6,
        used_quantity: 0,
        t1_quantity: 0,
        realised_quantity: 6,
        authorised_quantity: 0,
        authorised_date: "2023-05-18 00:00:00",
        authorisation: {},
        opening_quantity: 6,
        short_quantity: 0,
        collateral_quantity: 0,
        collateral_type: "",
        discrepancy: false,
        average_price: 78.85,
        last_price: 63.56,
        close_price: 63.57,
        pnl: -91.73999999999995,
        day_change: -0.00999999999999801,
        day_change_percentage: -0.015730690577313213,
      },
      {
        tradingsymbol: "ICICITECH",
        exchange: "BSE",
        instrument_token: 139064580,
        isin: "INF109KC16I6",
        product: "CNC",
        price: 0,
        quantity: 9,
        used_quantity: 0,
        t1_quantity: 0,
        realised_quantity: 9,
        authorised_quantity: 0,
        authorised_date: "2023-05-18 00:00:00",
        authorisation: {},
        opening_quantity: 9,
        short_quantity: 0,
        collateral_quantity: 0,
        collateral_type: "",
        discrepancy: false,
        average_price: 30.67,
        last_price: 29.15,
        close_price: 29.16,
        pnl: -13.680000000000028,
        day_change: -0.010000000000001563,
        day_change_percentage: -0.03429355281207669,
      },
      {
        tradingsymbol: "KPITTECH",
        exchange: "BSE",
        instrument_token: 138918660,
        isin: "INE04I401011",
        product: "CNC",
        price: 0,
        quantity: 1,
        used_quantity: 0,
        t1_quantity: 0,
        realised_quantity: 1,
        authorised_quantity: 0,
        authorised_date: "2023-05-18 00:00:00",
        authorisation: {},
        opening_quantity: 1,
        short_quantity: 0,
        collateral_quantity: 0,
        collateral_type: "",
        discrepancy: false,
        average_price: 679.95,
        last_price: 935.15,
        close_price: 933.45,
        pnl: 255.19999999999993,
        day_change: 1.6999999999999318,
        day_change_percentage: 0.1821200921313334,
      },
      {
        tradingsymbol: "MANAKSIA",
        exchange: "NSE",
        instrument_token: 3890945,
        isin: "INE015D01022",
        product: "CNC",
        price: 0,
        quantity: 14,
        used_quantity: 0,
        t1_quantity: 0,
        realised_quantity: 14,
        authorised_quantity: 0,
        authorised_date: "2023-05-18 00:00:00",
        authorisation: {},
        opening_quantity: 14,
        short_quantity: 0,
        collateral_quantity: 0,
        collateral_type: "",
        discrepancy: false,
        average_price: 78,
        last_price: 135.7,
        close_price: 136.05,
        pnl: 807.7999999999998,
        day_change: -0.35000000000002274,
        day_change_percentage: -0.2572583608967458,
      },
      {
        tradingsymbol: "REDINGTON",
        exchange: "BSE",
        instrument_token: 136398084,
        isin: "INE891D01026",
        product: "CNC",
        price: 0,
        quantity: 15,
        used_quantity: 0,
        t1_quantity: 0,
        realised_quantity: 15,
        authorised_quantity: 0,
        authorised_date: "2023-05-18 00:00:00",
        authorisation: {},
        opening_quantity: 15,
        short_quantity: 0,
        collateral_quantity: 0,
        collateral_type: "",
        discrepancy: false,
        average_price: 163.18,
        last_price: 173.3,
        close_price: 173.45,
        pnl: 151.80000000000007,
        day_change: -0.14999999999997726,
        day_change_percentage: -0.08648025367539768,
      },
      {
        tradingsymbol: "SUULD",
        exchange: "NSE",
        instrument_token: 163329,
        isin: "INE591Q01016",
        product: "CNC",
        price: 0,
        quantity: 20,
        used_quantity: 0,
        t1_quantity: 0,
        realised_quantity: 20,
        authorised_quantity: 0,
        authorised_date: "2023-05-18 00:00:00",
        authorisation: {},
        opening_quantity: 20,
        short_quantity: 0,
        collateral_quantity: 0,
        collateral_type: "",
        discrepancy: false,
        average_price: 43.2025,
        last_price: 11.85,
        close_price: 12.45,
        pnl: -627.05,
        day_change: -0.5999999999999996,
        day_change_percentage: -4.819277108433733,
      },
    ],
    upstox: [
      {
        avg_price: "31.84",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "ICICI Prudential Mutual Fund",
        haircut: 0.12,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INF109KC16I6",
        instrument_key_bse: "BSE_EQ|INF109KC16I6",
        instrument_key_nse: "NSE_EQ|INF109KC16I6",
        isin: "INF109KC16I6",
        product: "D",
        quantity: 201,
        symbol: "ICICITECH",
        t1_holding_qty: 0,
        token_bse: "543221",
        token_nse: "22365",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "41.12",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "ICICI Prudential Mutual Fund",
        haircut: 0.09,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INF109KC1NS5",
        instrument_key_bse: "BSE_EQ|INF109KC1NS5",
        instrument_key_nse: "NSE_EQ|INF109KC1NS5",
        isin: "INF109KC1NS5",
        product: "D",
        quantity: 17,
        symbol: "ICICINXT50",
        t1_holding_qty: 0,
        token_bse: "541809",
        token_nse: "4529",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "419.27",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "NIPPON INDIA ETF JUNIOR BEES",
        haircut: 0.08,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INF732E01045",
        instrument_key_bse: "BSE_EQ|INF732E01045",
        instrument_key_nse: "NSE_EQ|INF732E01045",
        isin: "INF732E01045",
        product: "D",
        quantity: 3,
        symbol: "JUNIORBEES",
        t1_holding_qty: 0,
        token_bse: "590104",
        token_nse: "10939",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "518.17",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "HDFC LIFE INSURANCE COMPANY LI3-68",
        haircut: 0.15,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INE795G01014",
        instrument_key_bse: "BSE_EQ|INE795G01014",
        instrument_key_nse: "NSE_EQ|INE795G01014",
        isin: "INE795G01014",
        product: "D",
        quantity: 7,
        symbol: "HDFCLIFE",
        t1_holding_qty: 0,
        token_bse: "540777",
        token_nse: "467",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "137.19",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "ICICI Prudential Nifty Low Vol2-18",
        haircut: 0.12,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INF109KB10T8",
        instrument_key_bse: "BSE_EQ|INF109KB10T8",
        instrument_key_nse: "NSE_EQ|INF109KB10T8",
        isin: "INF109KB10T8",
        product: "D",
        quantity: 4,
        symbol: "ICICILOVOL",
        t1_holding_qty: 0,
        token_bse: "540612",
        token_nse: "21254",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "181.32",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "NIPPON INDIA ETF NIFTY BEES",
        haircut: 0.08,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INF204KB14I2",
        instrument_key_bse: "BSE_EQ|INF204KB14I2",
        instrument_key_nse: "NSE_EQ|INF204KB14I2",
        isin: "INF204KB14I2",
        product: "D",
        quantity: 97,
        symbol: "NIFTYBEES",
        t1_holding_qty: 0,
        token_bse: "590103",
        token_nse: "10576",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "4104.30",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "Avenue Supermarts Limited",
        haircut: 0.15,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INE192R01011",
        instrument_key_bse: "BSE_EQ|INE192R01011",
        instrument_key_nse: "NSE_EQ|INE192R01011",
        isin: "INE192R01011",
        product: "D",
        quantity: 1,
        symbol: "DMART",
        t1_holding_qty: 0,
        token_bse: "540376",
        token_nse: "19913",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "183.41",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "ICICI Prudential Nifty ETF",
        haircut: 0.08,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INF109K012R6",
        instrument_key_bse: "BSE_EQ|INF109K012R6",
        instrument_key_nse: "NSE_EQ|INF109K012R6",
        isin: "INF109K012R6",
        product: "D",
        quantity: 3,
        symbol: "ICICINIFTY",
        t1_holding_qty: 0,
        token_bse: "537007",
        token_nse: "29553",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "916.65",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "MOTILAL OSWAL FINANCIAL SERVIC4-58",
        haircut: 0.16,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INE338I01027",
        instrument_key_bse: "BSE_EQ|INE338I01027",
        instrument_key_nse: "NSE_EQ|INE338I01027",
        isin: "INE338I01027",
        product: "D",
        quantity: 1,
        symbol: "MOTILALOFS",
        t1_holding_qty: 0,
        token_bse: "532892",
        token_nse: "14947",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "712.05",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "AXIS BANK LTD.",
        haircut: 0.14,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INE238A01034",
        instrument_key_bse: "BSE_EQ|INE238A01034",
        instrument_key_nse: "NSE_EQ|INE238A01034",
        isin: "INE238A01034",
        product: "D",
        quantity: 12,
        symbol: "AXISBANK",
        t1_holding_qty: 0,
        token_bse: "532215",
        token_nse: "5900",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "4.99",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "WinPro Industries Limited",
        haircut: 1,
        holdings_update_qty: 0,
        instrument_key: "BSE_EQ|INE974C01022",
        instrument_key_bse: "BSE_EQ|INE974C01022",
        instrument_key_nse: "",
        isin: "INE974C01022",
        product: "D",
        quantity: 16,
        symbol: "WINPRO",
        t1_holding_qty: 0,
        token_bse: "531337",
        token_nse: "",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "99.04",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "ICICI Prudential NV20 ETF",
        haircut: 0.25,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INF109KB1WY5",
        instrument_key_bse: "BSE_EQ|INF109KB1WY5",
        instrument_key_nse: "NSE_EQ|INF109KB1WY5",
        isin: "INF109KB1WY5",
        product: "D",
        quantity: 8,
        symbol: "ICICINV20",
        t1_holding_qty: 0,
        token_bse: "539945",
        token_nse: "17475",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "3294.00",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "ALKYL AMINES CHEMICALS LTD.",
        haircut: 0.17,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INE150B01039",
        instrument_key_bse: "BSE_EQ|INE150B01039",
        instrument_key_nse: "NSE_EQ|INE150B01039",
        isin: "INE150B01039",
        product: "D",
        quantity: 1,
        symbol: "ALKYLAMINE",
        t1_holding_qty: 0,
        token_bse: "506767",
        token_nse: "4487",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "2326.13",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "HINDUSTAN UNILEVER LTD.",
        haircut: 0.12,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INE030A01027",
        instrument_key_bse: "BSE_EQ|INE030A01027",
        instrument_key_nse: "NSE_EQ|INE030A01027",
        isin: "INE030A01027",
        product: "D",
        quantity: 4,
        symbol: "HINDUNILVR",
        t1_holding_qty: 0,
        token_bse: "500696",
        token_nse: "1394",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
      {
        avg_price: "1437.62",
        cnc_used_quantity: 0,
        collateral_qty: 0,
        collateral_type: "WC",
        collateral_update_qty: 0,
        company_name: "HDFC BANK LTD.",
        haircut: 0.12,
        holdings_update_qty: 0,
        instrument_key: "NSE_EQ|INE040A01034",
        instrument_key_bse: "BSE_EQ|INE040A01034",
        instrument_key_nse: "NSE_EQ|INE040A01034",
        isin: "INE040A01034",
        product: "D",
        quantity: 3,
        symbol: "HDFCBANK",
        t1_holding_qty: 0,
        token_bse: "500180",
        token_nse: "1333",
        traded_qty: 0,
        withheld_collateral_qty: 0,
        withheld_holding_qty: 0,
      },
    ],
  },
  watchlistedStocks: [],
};

export const UserContext = createContext({});
